module.exports = {
	"data": {
		"0C00004JD2": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/556/Global-Palm-Resources-Holdings-Ltd",
			"zsl_spott": ""
		},
		"0C00006IRB": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000BO5": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/johnson-johnson",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000016E0": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.theguardian.com/sustainable-business/2015/aug/10/india-palm-oil-sustainability-deforestation-unilever-greenpeace",
			"rspo": "https://rspo.org/uploads/default/scc/HINDUSTAN_UNILEVER_LIMITED_INDIA_certificate.pdf",
			"zsl_spott": ""
		},
		"0C00000Y1U": {
			"banktrack": "https://www.banktrack.org/company/wilmar_group",
			"forest500": "https://forest500.org/rankings/companies/wilmar-international-ltd",
			"supply_change": "http://www.supply-change.org/company/wilmar-international",
			"other_link": "",
			"rspo": "https://rspo.org/members/88/Wilmar-International-Limited",
			"zsl_spott": "https://www.spott.org/palm-oil/wilmar-international-ltd/"
		},
		"0C00003C57": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Y80": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/meiji-holdings-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Y1I": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/33/united-plantations-bhd",
			"zsl_spott": ""
		},
		"0C00000Y88": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kikkoman-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000AEB": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/archer-daniels-midland-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/151/Archer-Daniels-Midland-ADM",
			"zsl_spott": "https://www.spott.org/palm-oil/archer-daniels-midland-company-adm/"
		},
		"0C000008P2": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/r-r-donnelley-sons-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003ALL": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.reuters.com/article/us-indonesia-food-estate/greens-fear-indonesia-forest-loss-for-food-estate-idUSTRE62O2BU20100325",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000FOT": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/klabin-sa",
			"supply_change": "http://www.supply-change.org/company/klabin",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/klabin-sa/"
		},
		"0C000017O5": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/grupo-slc",
			"supply_change": "",
			"other_link": "https://chainreactionresearch.com/the-chain-slc-agricola-clears-1355-hectares-of-cerrado-vegetation-despite-customer-zero-deforestation-commitments/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003ALY": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/slj-global-tbk/"
		},
		"0C00000GXI": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/toyo-suisan-kaisha-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/8755/Toyo-Suisan-KaishaLtd",
			"zsl_spott": ""
		},
		"0C00003ALU": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/sinar-mas-group-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.smart-tbk.com/en/berkelanjutan/standar-sertifikasi/rspo/",
			"zsl_spott": ""
		},
		"0C000018DK": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://forest500.org/rankings/companies/magnit-group",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000AJ1": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/avon-products-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/707",
			"zsl_spott": ""
		},
		"0C0000A4B0": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/150/pt-austindo-nusantara-jaya-agri",
			"zsl_spott": "https://www.spott.org/palm-oil/austindo-nusantara-jaya-tbk-pt/"
		},
		"0C00000XD6": {
			"banktrack": "https://www.banktrack.org/bank/uob",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BJL": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://complaints.oecdwatch.org/cases/Case_491/@@casesearchview?type=Company&search=POSCO",
			"zsl_spott": "https://www.spott.org/palm-oil/posco-daewoo-corporation/"
		},
		"0C00000O38": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "http://www.supply-change.org/company/anglo-eastern-plantations",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000017OE": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/duratex-sa/"
		},
		"0C00008O5W": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Y8G": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Y8P": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/fast-retailing",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000015OQ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/uni-president-enterprises-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C5D": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C5E": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/wtk-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/wtk-holdings-bhd/"
		},
		"0C00003C5A": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/inner-mongolia-yili-industrial-group-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000AXM": {
			"banktrack": "https://www.banktrack.org/bank/deutsche_bank",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000XVP": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/salim-group",
			"supply_change": "http://www.supply-change.org/company/indofood-agri-resources",
			"other_link": "",
			"rspo": "https://www.ofimagazine.com/news/indofood-withdraws-from-rspo",
			"zsl_spott": ""
		},
		"0C00002BDX": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/nisshin-oillio-group-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000CTF": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/unilever-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/107/unilever",
			"zsl_spott": ""
		},
		"0C00000CTG": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/unilever-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/107/unilever",
			"zsl_spott": ""
		},
		"0C000007IQ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/estee-lauder-companies-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/3655/The-Estee-Lauder-Companies-Inc",
			"zsl_spott": ""
		},
		"0C00000UOX": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/china-mengniu-dairy-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000UOO": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/li-ning-company-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00002B00": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/nitori-holdings-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000ASGH": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/restaurant-brands-international",
			"supply_change": "",
			"other_link": "https://blog.ucsusa.org/lael-goodman/americas-top-brands-cattle-and-deforestation",
			"rspo": "https://rspo.org/members/5853/Restaurant-Brands-International-Inc",
			"zsl_spott": ""
		},
		"0C00000Y6S": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/seven-i-holdings-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000ASO": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/cresud-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000ASH": {
			"banktrack": "https://www.banktrack.org/bank/credit_suisse",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000G6E": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/orkla-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000E4U": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/aeon-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00009EVV": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000035X9": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/socfin-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/8070/Socfin-SA",
			"zsl_spott": ""
		},
		"0C00000VLA": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/rougier-group/"
		},
		"0C00003GKL": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/china-state-construction-engineering-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000BJN": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/international-paper",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/international-paper/"
		},
		"0C00008HZ6": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/amorepacific-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00002BQL": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kewpie-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000009PY": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/wolverine-world-wide-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000056RS": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "http://www.supply-change.org/company/eagle-high-plantations",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/225/pt-bw-plantation-tbk",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/eagle-high-plantations-tbk-pt/"
		},
		"0C00000VC1": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/greenheart-group-ltd/"
		},
		"0C00003BVA": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000007BH": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/ck-hutchison-holdings",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00009AO6": {
			"banktrack": "https://www.banktrack.org/company/bumitama",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/2551/BUMITAMA-AGRI-LTD",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/bumitama-agri-ltd/"
		},
		"0C00000FON": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kingfisher-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003COU": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/hap-seng-plantation-holdings-bhd/"
		},
		"0C00000UTO": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/hengan-international",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000035XA": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/socfin-group",
			"supply_change": "http://www.supply-change.org/company/socfin-group",
			"other_link": "",
			"rspo": "https://rspo.org/members/8070/Socfin-SA",
			"zsl_spott": "https://www.spott.org/palm-oil/socfin-group-s-a/"
		},
		"0C00000XXX": {
			"banktrack": "https://www.banktrack.org/company/olam",
			"forest500": "https://forest500.org/rankings/companies/olam-international",
			"supply_change": "http://www.supply-change.org/company/olam-international",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/754/olam-international-limited",
			"zsl_spott": "https://www.spott.org/palm-oil/olam-international-ltd/"
		},
		"0C00000XXZ": {
			"banktrack": "https://www.banktrack.org/bank/ocbc",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000BC7": {
			"banktrack": "https://www.banktrack.org/bank/hsbc",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000008FY": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/mitsui-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000008FX": {
			"banktrack": "https://www.banktrack.org/bank/bank_of_tokyo_mitsubishi_ufj",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000095ED": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/capri-holdings-limited",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000NYY": {
			"banktrack": "https://www.banktrack.org/company/astra_agro",
			"forest500": "",
			"supply_change": "http://www.supply-change.org/company/astra-agro-lestari",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/astra-agro-lestari-tbk-pt/"
		},
		"0C00000XC7": {
			"banktrack": "https://www.banktrack.org/company/golden_agri",
			"forest500": "",
			"supply_change": "http://www.supply-change.org/company/golden-agri-resources",
			"other_link": "",
			"rspo": "https://rspo.org/members/719/Golden-Agri-Resources-Ltd",
			"zsl_spott": "https://www.spott.org/palm-oil/golden-agri-resources-ltd/"
		},
		"0C000009NT": {
			"banktrack": "https://www.banktrack.org/bank/westpac",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000007U5": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/general-mills-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/1117/General-Mills-Inc",
			"zsl_spott": ""
		},
		"0C00002DDZ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/mcdonalds-corp",
			"supply_change": "",
			"other_link": "https://blog.ucsusa.org/lael-goodman/americas-top-brands-cattle-and-deforestation",
			"rspo": "https://rspo.org/members/908/McDonalds-Corporation",
			"zsl_spott": ""
		},
		"0C00008FJD": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/mewah-international-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003ASZ": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003ASH": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/155/PT.-Sampoerna-Agro-Tbk",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/sampoerna-agro-tbk-pt/"
		},
		"0C0000AO13": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/wh-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000B6K": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/hain-celestial-group-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000OOL": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/xiamen-xindeco-ltd/"
		},
		"0C000055PC": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.globalwitness.org/documents/17779/no_forests_left.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000055F7": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/emami-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000009IA": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/vf-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Y70": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/oji-holdings-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/oji-holdings/"
		},
		"0C00003N64": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/coty-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000P4C": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/shanghai-construction-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00002B6H": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/asics-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000VZU": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/casino-guichard-perrachon-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000VZW": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/carrefour-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00002BXU": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/sumitomo-forestry",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/sumitomo-forestry-co-ltd/"
		},
		"0C00000BGZ": {
			"banktrack": "https://www.banktrack.org/bank/ing",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000B2H0": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000017G0": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://seekingalpha.com/article/4114248-farmland-investments-in-brazilian-cerrado-financial-environmental-and-social-risks",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000BGB": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.greenpeace.org/usa/wp-content/uploads/legacy/Global/usa/planet3/PDFs/slaughtering-the-amazon-part-1.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C4S": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C4V": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.globalwitness.org/en/campaigns/forests/money-to-burn-how-iconic-banks-and-investors-fund-the-destruction-of-the-worlds-largest-rainforests/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Q6S": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/reckitt-benckiser-group-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/102/Reckitt-Benckiser-PLC",
			"zsl_spott": ""
		},
		"0C00001505": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/charoen-pokphand-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C4X": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/5/Boustead-Plantations-Berhad",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/boustead-plantations-bhd/"
		},
		"0C000017OB": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/alpargatas-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000008A4": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/mcdonalds-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/908/McDonalds-Corporation",
			"zsl_spott": ""
		},
		"0C00003C4H": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/genting-bhd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BLL": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/lotte-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000ASTJ": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/golden-plantation-tbk-pt/"
		},
		"0C00000CQI": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/wendys-co",
			"supply_change": "",
			"other_link": "https://blog.ucsusa.org/lael-goodman/americas-top-brands-cattle-and-deforestation",
			"rspo": "https://rspo.org/members/4178/Wendys-International-LLC",
			"zsl_spott": ""
		},
		"0C00000Q49": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://actions.sumofus.org/a/samsung-get-out-of-conflict-palm-oil",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000016ZL": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/ruchi-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000D28": {
			"banktrack": "https://www.banktrack.org/bank/bnp_paribas",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BK3": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/lotte-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000008HA": {
			"banktrack": "https://www.banktrack.org/bank/morgan_stanley",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000C5L": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/pearson-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00008Q21": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/glencore",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000V41": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003AO4": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://fairfinanceguide.org/ffg-international/stories-of-change/2019/the-ongoing-struggle-to-end-banks-relationships-with-controversial-palm-oil-companies-indonesia/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000B9P9": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Y7T": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://climatefocus.com/sites/default/files/20180626%20WP1%20Annex.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003H3H": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://news.mongabay.com/2013/03/norways-wealth-fund-dumps-23-palm-oil-companies-under-new-deforestation-policy/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003AS6": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/bumi-teknokultura-unggul-tbk-btek/"
		},
		"0C000095S3": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/765/TDM-Plantation-Sdn-Bhd",
			"zsl_spott": ""
		},
		"0C00000GRG": {
			"banktrack": "https://www.banktrack.org/bank/sumitomo_mitsui_banking_corporation",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000PAI": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/shandong-chenming-paper-holdings-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C9N": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000006UX": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/basf-se",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003CHC": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "http://www.rspo.org/sites/default/files/IJM.pdf",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/ijm-plantations-bhd/"
		},
		"0C00006ISO": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003CHM": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://news.mongabay.com/2013/03/norways-wealth-fund-dumps-23-palm-oil-companies-under-new-deforestation-policy/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000VOS": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/lvmh-moet-hennessy-louis-vuitton-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000AP3": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/conagra-brands-inc",
			"supply_change": "",
			"other_link": "https://blog.ucsusa.org/lael-goodman/americas-top-brands-cattle-and-deforestation",
			"rspo": "https://www.rspo.org/members/92/conagra-foods-inc",
			"zsl_spott": ""
		},
		"0C00000XN1": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/neste-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00002BUQ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/yakult-honsha-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003COR": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://forest500.org/firm-recovers-oil-palm-land",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/sarawak-oil-palms-bhd/"
		},
		"0C00000BUB": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/nike-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003COQ": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00008TKT": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/samsonite-international-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000FNV": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kao-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/169/Kao-Corporation",
			"zsl_spott": ""
		},
		"0C0000BCKF": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/godrej-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000AOT5": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/5/Boustead-Plantations-Berhad",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/boustead-plantations-bhd/"
		},
		"0C00000WW7": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000AKL": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/clorox-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/4319/The-Clorox-Company",
			"zsl_spott": ""
		},
		"0C00002AZ4": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://actions.sumofus.org/a/noodles-palm-oil",
			"rspo": "https://rspo.org/members/6931/Nissin-Foods-Holdings-Co.-Ltd",
			"zsl_spott": ""
		},
		"0C00003BWT": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/sarawak-oil-palms-bhd/"
		},
		"0C00000NC8": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BWO": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000NC0": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/saint-gobain-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Q0R": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/adidas-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000095Q": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/3m-company",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000BBPS": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/aditya-birla-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000XIO": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/aak-ab",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000014W8": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/04/2018_April_25_Goodyear_Investigation_FINAL.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000XIE": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://b8f65cb373b1b7b15feb-c70d8ead6ced550b4d987d7c03fcdd1d.ssl.cf3.rackcdn.com/cms/reports/documents/000/001/328/original/CDP_2016_forests_report.pdf?1482313940",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000N7Y": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/marks-spencer-group-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/117/marks-and-spencer-plc",
			"zsl_spott": ""
		},
		"0C000035IF": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://taann.files.wordpress.com/2012/01/ta_ann_report_final3.pdf",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/ta-ann-holdings-bhd/"
		},
		"0C00000YKD": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/mondi-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000GLO": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/shiseido-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000E2B": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003AK9": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000B5G": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/danone",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/881/Danone",
			"zsl_spott": ""
		},
		"0C00003AK4": {
			"banktrack": "https://www.banktrack.org/bank/bank_danamon",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003GQE": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003CKT": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000ALZ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/colgate-palmolive-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/1163/Colgate-Palmolive-Company",
			"zsl_spott": ""
		},
		"0C00003CBM": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000BA8Q": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/metro-ag",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000AKJG": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/lenta-ooo",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C08": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/golden-pharos-bhd/"
		},
		"0C000017MS": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/natura-cosmeticos-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00009E2G": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kraft-heinz-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/121/h-j-heinz-company-ltd",
			"zsl_spott": ""
		},
		"0C00000AL0": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/tapestry",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000017MI": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/minerva-sa",
			"supply_change": "",
			"other_link": "https://news.mongabay.com/2018/11/deforestation-linked-brazilian-beef-still-flowing-into-international-markets-report/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000697O": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/nippon-paper-industries-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000BBV": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/hormel-foods-corp",
			"supply_change": "",
			"other_link": "https://blog.ucsusa.org/lael-goodman/americas-top-brands-cattle-and-deforestation",
			"rspo": "https://rspo.org/members/6247/Hormel-Foods-Corporation",
			"zsl_spott": ""
		},
		"0C00000BP2": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kellogg-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000007DF": {
			"banktrack": "https://www.banktrack.org/bank/citi",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000D8G": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/koninklijke-dsm-nv",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003AKL": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/barito-pacific/"
		},
		"0C00000D8B": {
			"banktrack": "https://www.banktrack.org/bank/dbs",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003AKB": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/salim-group",
			"supply_change": "",
			"other_link": "https://chainreactionresearch.com/reports/indofood-sukses-makmur-and-first-pacific/",
			"rspo": "https://www.ofimagazine.com/news/indofood-withdraws-from-rspo",
			"zsl_spott": ""
		},
		"0C00003AKD": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/178/PT.-Bakrie-Sumatera-Plantations-TBK/group-member",
			"zsl_spott": "http://www.rspo.org/members/178/PT-Bakrie-Sumatera-Plantations-TBK"
		},
		"0C00003AKE": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/178/PT.-Bakrie-Sumatera-Plantations-TBK/group-member",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/bakrie-sumatera-plantations-tbk-pt/"
		},
		"0C00000OED": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/new-hope-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BZ2": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003AR0": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000082B": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/lear-corp-0",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000014N3": {
			"banktrack": "https://www.banktrack.org/company/first_resources",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/193/first-resources-limited",
			"zsl_spott": "https://www.spott.org/palm-oil/first-resources-ltd/"
		},
		"0C00000CI7": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000AZX": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/dominos-pizza-inc",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "https://rspo.org/members/3733/Dominos-Pizza-Inc",
			"zsl_spott": ""
		},
		"0C000006U3": {
			"banktrack": "https://www.banktrack.org/bank/bank_of_america",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000FXV": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/mitsubishi-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000UIW": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/maxingvest-ag",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/724",
			"zsl_spott": ""
		},
		"0C0000A4YO": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/1891/PT.-DHARMA-SATYA-NUSANTARA",
			"zsl_spott": "https://www.spott.org/palm-oil/dharma-satya-nusantara-tbk/"
		},
		"0C00000GKX": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/sekisui-house-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000017FE": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.sec.gov/Archives/edgar/data/1499849/000119312513420522/d621008d20f.htm",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000GWW": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/toppan-printing-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003AU6": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/gozco-plantations-tbk-pt/"
		},
		"0C00003EEF": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "http://www.supply-change.org/company/goodhope-asia-holdings"
		},
		"0C00003EED": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://s3-eu-west-1.amazonaws.com/oneworld-wp/app/uploads/2017/01/07102223/www.greenpeace.org_international_Global_international_publications_forests_2017_Greenpeace_DirtyBankers_final.pdf",
			"rspo": "https://rspo.org/members/3466/Goodhope-Asia-Holdings-Ltd",
			"zsl_spott": ""
		},
		"0C0000166G": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/emami-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BZZ": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.climateadvisers.com/palm-oil-companies-withstanding-pressure-for-greater-sustainability/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000CIT": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/target-corp",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "https://rspo.org/members/4572/Target-Corporation",
			"zsl_spott": ""
		},
		"0C00000AUE": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/5535/CVS-Health-Corporation",
			"zsl_spott": ""
		},
		"0C00000L3L": {
			"banktrack": "https://www.banktrack.org/bank/mizuho",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BZH": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000822": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.globalcanopy.org/sites/default/files/documents/resources/FifteenkeycompaniesinEUandUS_table%203.4.19.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000006UP": {
			"banktrack": "https://www.banktrack.org/bank/barclays",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000007YN": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kimberly-clark-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00008FR5": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/dunkin-brands-group-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/6130/Dunkin-Brands-Group-Inc/group-member",
			"zsl_spott": ""
		},
		"0C00000BMS": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/jm-smucker",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/1592/The-J.M.-Smucker-Company",
			"zsl_spott": ""
		},
		"0C00000BMT": {
			"banktrack": "https://www.banktrack.org/bank/jpmorgan_chase",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BT9": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/socfin-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003DAP": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/colgate-palmolive-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/1163/Colgate-Palmolive-Company",
			"zsl_spott": ""
		},
		"0C00003GUN": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/107/unilever",
			"zsl_spott": ""
		},
		"0C00000XFG": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/h-m-hennes-mauritz-ab",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00006IUE": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000156A": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/pou-chen",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BTU": {
			"banktrack": "https://www.banktrack.org/bank/cimb",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000009RV": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/ypf",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000B9Q2": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/integra-group/"
		},
		"0C000017IC": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/cyrela-brazil-realty",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000008LL": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/procter-gamble-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/669",
			"zsl_spott": ""
		},
		"0C000009RZ": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://blog.ucsusa.org/lael-goodman/americas-top-brands-cattle-and-deforestation",
			"rspo": "https://rspo.org/members/7011/YUM-Brands-Inc",
			"zsl_spott": ""
		},
		"0C00009U16": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/natural-rubber/halcyon-agri/"
		},
		"0C000014TF": {
			"banktrack": "https://www.banktrack.org/bank/bangkok_bank",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C3F": {
			"banktrack": "https://www.banktrack.org/company/ioi_corporation",
			"forest500": "https://forest500.org/rankings/companies/ioi-corporation-bhd",
			"supply_change": "http://www.supply-change.org/company/ioi-group",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/62/IOI-Group",
			"zsl_spott": "https://www.spott.org/palm-oil/ioi-corporation-bhd/"
		},
		"0C00000VN7": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C3L": {
			"banktrack": "https://www.banktrack.org/company/kuala_lumpur_kepong",
			"forest500": "https://forest500.org/rankings/companies/kuala-lumpur-kepong-bhd",
			"supply_change": "http://www.supply-change.org/company/kuala-lumpur-kepong-berhad-klk",
			"other_link": "",
			"rspo": "https://rspo.org/members/13/Kuala-Lumpur-Kepong-Berhad",
			"zsl_spott": ""
		},
		"0C00003C3M": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.theedgemarkets.com/article/its-business-usual-wilmar-says-ppb",
			"rspo": "http://www.rspo.org/sites/default/files/PPB.pdf",
			"zsl_spott": ""
		},
		"0C00003C3K": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/931/Hap-Seng-Plantations-Holdings-Bhd",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/hap-seng-plantation-holdings-bhd/"
		},
		"0C00000OHG": {
			"banktrack": "https://www.banktrack.org/bank/bank_of_china",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003CE1": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/173/QL-Resources-Berhad",
			"zsl_spott": "https://www.spott.org/palm-oil/ql-resources-bhd/"
		},
		"0C000038PB": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/cencosud",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00004B1H": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/jvl-agro-industries-ltd",
			"supply_change": "",
			"other_link": "https://chainreactionresearch.com/report/leakage-risks-in-india-58-percent-of-palm-oil-imports-not-covered-by-ndpe-policies/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003AQJ": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/25/PT-Tunas-Baru-Lampung-Tbk",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/tunas-baru-lampung-tbk-pt/"
		},
		"0C00003AQE": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/news-and-events/news/rspo-ceos-response-to-letter-from-pt-pp-london-sumatra-indonesia-tbk-subsidiary-of-salim-ivomas-pratama-tbk",
			"zsl_spott": "https://www.spott.org/palm-oil/london-sumatra-pp-tbk-pt/"
		},
		"0C00003AQC": {
			"banktrack": "https://www.banktrack.org/bank/bank_mandiri",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000OHJ": {
			"banktrack": "https://www.banktrack.org/bank/industrial_commercial_bank_of_china",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000B0E": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/dupont",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000AHZ": {
			"banktrack": "https://www.banktrack.org/bank/anz",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000035H4": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/sime-darby-bhd",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/29/Sime-Darby-Plantation-Berhad",
			"zsl_spott": "https://www.spott.org/palm-oil/sime-darby-plantation-sdn-bhd/"
		},
		"0C00000C6W": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/pepsico-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/300",
			"zsl_spott": ""
		},
		"0C00008QWB": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/future-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000GSL": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/suzano-s-a/"
		},
		"0C00000726": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/bunge-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/176/bunge",
			"zsl_spott": "https://www.spott.org/palm-oil/bunge-ltd/"
		},
		"0C00003CEU": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/priceworth-international/"
		},
		"0C000017LZ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/marfrig-global-foods",
			"supply_change": "",
			"other_link": "https://news.mongabay.com/2018/11/deforestation-linked-brazilian-beef-still-flowing-into-international-markets-report/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000008QT": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/relx-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000017LT": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/mrv-engenharia-e-participacoes-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00008UBL": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/prada-spa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00008JX1": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/adecoagro-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Q6A": {
			"banktrack": "https://www.banktrack.org/bank/standard_chartered",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00002BSQ": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000Q6J": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/200/R.E.A.-Holdings-Plc",
			"zsl_spott": "https://www.spott.org/palm-oil/r-e-a-holdings-plc/"
		},
		"0C00009UQZ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/dekeloil",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C6W": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/2597/TSH-Resources-Berhad",
			"zsl_spott": "https://www.spott.org/palm-oil/tsh-resources-bhd/"
		},
		"0C00003AJP": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/pt-astra-international-tbk",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/astra-agro-lestari-tbk-pt/"
		},
		"0C00003C6H": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00002BSC": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/daio-paper-corporation",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00004HQT": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kuala-lumpur-kepong-bhd",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.epoil.co.uk/our-sustainable-approach/rspo-membership/",
			"zsl_spott": "https://www.spott.org/palm-oil/kuala-lumpur-kepong-bhd/"
		},
		"0C00003AJC": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/astra-agro-lestari-tbk-pt/"
		},
		"0C00000UM1": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.greenpeace.org/usa/forests/boreal/clearcutting-free-speech/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003C65": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/2/genting-plantations-berhad",
			"zsl_spott": "https://www.spott.org/palm-oil/genting-plantations-bhd/"
		},
		"0C00000Q62": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/j-sainsburys-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000152W": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/259/lam-soon-thailand-plc",
			"zsl_spott": ""
		},
		"0C00000Q68": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/wm-morrison-supermarkets-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000AUJ3": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/salim-group",
			"supply_change": "",
			"other_link": "https://chainreactionresearch.com/reports/indofood-sukses-makmur-and-first-pacific/",
			"rspo": "https://www.ofimagazine.com/news/indofood-withdraws-from-rspo",
			"zsl_spott": ""
		},
		"0C00000X07": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/lindt-sprungli-ag",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000017L0": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/jbs",
			"supply_change": "",
			"other_link": "https://chainreactionresearch.com/report/cattle-driven-deforestation-a-major-risk-to-brazilian-retailers/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000092J": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/skechers-usa-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00008O49": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/tangrenshen-group-trs",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000BA0": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/hershey-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/810/The-Hershey-Company",
			"zsl_spott": ""
		},
		"0C00000BB5": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/home-depot",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00009CZO": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/5855/FGV-HOLDINGS-BERHAD",
			"zsl_spott": ""
		},
		"0C00000ARG": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/costco-wholesale-corporation",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "https://rspo.org/members/4599/Costco-Wholesale-Corporation",
			"zsl_spott": ""
		},
		"0C000009EB": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/amazon",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000006TP": {
			"banktrack": "https://www.banktrack.org/bank/bbva",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000OI2": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/yihua-life/"
		},
		"0C00000XBO": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003CJ1": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/bld-plantation-bhd-bintulu-lumber-development-bld-plantation/"
		},
		"0C00000VAN": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00006IQE": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000UXC": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/gold-best-holdings",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000A5B6": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/news-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000OIS": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/inner-mongolia-yili-industrial-group-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00006IQZ": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/natural-rubber/hagl-group/"
		},
		"0C00008I13": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/cj-cheiljedang-corporation",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003AMO": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/107/unilever",
			"zsl_spott": ""
		},
		"0C00008Q4W": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000W0J": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/groupe-savencia-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00002BZL": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/unicharm-corporation",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000009L0": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/wal-mart-stores-inc",
			"supply_change": "",
			"other_link": "https://blog.ucsusa.org/lael-goodman/americas-top-brands-cattle-and-deforestation",
			"rspo": "https://www.rspo.org/members/749",
			"zsl_spott": ""
		},
		"0C00000W0M": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.grain.org/en/article/6238-bollore-group-sued-by-ngos-in-an-unprecedented-legal-action",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000CS9": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/tyson-foods-inc",
			"supply_change": "",
			"other_link": "https://www.ran.org/the-understory/tyson_foods/",
			"rspo": "https://rspo.org/members/6510/Tyson-Foods-Inc",
			"zsl_spott": ""
		},
		"0C000038M6": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/empresas-cmpc/"
		},
		"0C000018U7": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/grupo-bimbo-sab-de-cv",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/9111/Corporativo-Bimbo-S.A.-de-C.V",
			"zsl_spott": ""
		},
		"0C00000GI5": {
			"banktrack": "https://www.banktrack.org/bank/rbs",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000008UQ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/royal-dutch-shell",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000085J": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/lowes-companies-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000008CA": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/meredith-corporation",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000P74": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/x5-retail-group-nv",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000085E": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/loreal-sa-0",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/142/loreal",
			"zsl_spott": ""
		},
		"0C000008JP": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://complaints.oecdwatch.org/cases/Case_491/@@casesearchview?type=Company&search=POSCO",
			"rspo": "https://complaints.oecdwatch.org/cases/Case_491/@@casesearchview?type=Company&search=POSCO",
			"zsl_spott": "https://www.spott.org/palm-oil/posco-international/"
		},
		"0C00000UNP": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/nine-dragons-paper-holdings",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003BU5": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003ATQ": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/toba-pulp-lestari-tbk-pt/"
		},
		"0C00000CD6": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/starbucks-corp",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "https://rspo.org/members/5159/Starbucks-Corporation",
			"zsl_spott": ""
		},
		"0C000008JD": {
			"banktrack": "https://www.banktrack.org/bank/national_australia_bank_group",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00009DBD": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/zhejiang-tongtianxing-group-joint-stock-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000AJEN": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/1043/PT.-Sawit-Sumbermas-Sarana",
			"zsl_spott": "https://www.spott.org/palm-oil/sawit-sumbermas-sarana-tbk-pt/"
		},
		"0C000018GI": {
			"banktrack": "https://www.banktrack.org/company/kencana_group",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000APSA": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/japfa-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000CEM": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/stora-enso",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000BRK": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/nestle-sa",
			"supply_change": "",
			"other_link": "https://blog.ucsusa.org/lael-goodman/americas-top-brands-cattle-and-deforestation",
			"rspo": "https://rspo.org/members/458/Nestle-S.A",
			"zsl_spott": ""
		},
		"0C00008T5T": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/salim-group",
			"supply_change": "",
			"other_link": "https://theinsiderstories.com/indonesias-salim-ivomas-withdraws-rspo-membership/",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/salim-ivomas-pratama-tbk-pt/"
		},
		"0C00003JAO": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/foshan-saturday-shoes-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000014NA": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/samko-timber-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000FU1": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/marubeni/"
		},
		"0C00003CDL": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.theedgemarkets.com/article/highest-returns-shareholders-over-three-years-plantation-kim-loong-resources-bhd-planter-and",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000VM2": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kering-sa",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000NZB": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/tesco-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000CVT": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/upm",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000B5MB": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/adient",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00008VP6": {
			"banktrack": "https://www.banktrack.org/bank/abn_amro",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000BE71": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/timber-pulp/alpi/"
		},
		"0C000007ZQ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/koninklijke-dsm-nv",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003CD6": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00009D2W": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/107/unilever",
			"zsl_spott": ""
		},
		"0C00000LHD": {
			"banktrack": "https://www.banktrack.org/bank/commonwealth_bank",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000007ZZ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/mondelez-international-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/952/Mondelez-International-Inc",
			"zsl_spott": ""
		},
		"0C0000AYRE": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000ESE": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/dai-nippon-printing",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000ESH": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/daiwa-house-group",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000CE7": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/steve-madden-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000802": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/kroger-co",
			"supply_change": "",
			"other_link": "https://blog.ucsusa.org/lael-goodman/americas-top-brands-cattle-and-deforestation",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000WM1": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/156/SIPEF-Group",
			"zsl_spott": "https://www.spott.org/palm-oil/sipef/"
		},
		"0C00003AP3": {
			"banktrack": "",
			"forest500": "http://forestsandfinance.org/wp-content/uploads/2017/06/Forestsandfinance.org-Adjusters-June-2017.xlsx",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000NHM": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/associated-british-foods-plc",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://www.rspo.org/members/662",
			"zsl_spott": ""
		},
		"0C00000H9A": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/yamazaki-baking-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000093N": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "http://www.mightyearth.org/wp-content/uploads/2018/08/Flunking-the-Planet-Americas-Leading-Food-Companies-Fail-on-Sustainable-Meat.pdf",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00002AUH": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://chainreactionresearch.com/the-chain-main-southeast-asian-deforesters-of-2019-still-supplying-the-ndpe-market/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000OXN": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.globalwitness.org/en/campaigns/forests/role-french-banks-global-forest-destruction/",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000CN4": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/thomson-reuters",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00003DES": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/6094/Bayer-AG",
			"zsl_spott": ""
		},
		"0C00003APJ": {
			"banktrack": "https://www.banktrack.org/bank/bank_rakyat_indonesia",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000AWPQ": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/guangdong-wens-foodstuff-group-co-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000UK6": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/henkel-ag-co-kgaa",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/6073/Henkel-AG-Co.-KGaA",
			"zsl_spott": ""
		},
		"0C00000CNY": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/tjx-companies",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000AWC": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/deckers-outdoor-corp",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C000014Q2": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/294/Univanich-Palm-Oil-Public-Company-Limited",
			"zsl_spott": ""
		},
		"0C0000B68D": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/cofco",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000B9MD": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/essity",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000NAD": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "https://www.spott.org/palm-oil/m-p-evans-group-plc/"
		},
		"0C00003APU": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "",
			"other_link": "https://www.banktrack.org/download/rogue_trader_keeping_deforestration_in_the_family/rogue_trade_keeping_deforestration_in_the_family.pdf",
			"rspo": "https://rspo.org/members/88/Wilmar-International-Limited",
			"zsl_spott": ""
		},
		"0C00000MGF": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/woolworths-group-ltd",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C0000BDAW": {
			"banktrack": "",
			"forest500": "",
			"supply_change": "http://www.supply-change.org/company/sime-darby-plantation",
			"other_link": "",
			"rspo": "",
			"zsl_spott": "http://www.sustainablepalmoil.org/company/olam-international-ltd/"
		},
		"0C00000746": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/campbell-soup-co",
			"supply_change": "",
			"other_link": "",
			"rspo": "https://rspo.org/members/5979/Campbell-Soup-Company",
			"zsl_spott": ""
		},
		"0C00008N28": {
			"banktrack": "",
			"forest500": "https://forest500.org/rankings/companies/calbee-inc",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		},
		"0C00000ENX": {
			"banktrack": "https://www.banktrack.org/bank/commerzbank",
			"forest500": "",
			"supply_change": "",
			"other_link": "",
			"rspo": "",
			"zsl_spott": ""
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/CompanyLinks.json
// module id = 361
// module chunks = 0